import { useState } from "react";
import { Smartphone } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { usePwaInstall } from "@/hooks/usePwaInstall";

const STEPS = [
  { title: "Android (Chrome)", text: "Ketuk menu titik tiga di pojok kanan atas, lalu pilih \"Instal aplikasi\" atau \"Tambahkan ke Layar utama\"." },
  { title: "iPhone (Safari)", text: "Ketuk tombol Bagikan (kotak dengan panah ke atas), lalu pilih \"Tambah ke Layar Utama\"." },
  { title: "Laptop / PC (Chrome / Edge)", text: "Klik ikon install di ujung kanan kolom alamat browser." },
];

export const InstallAppButton = ({ variant = "light" }) => {
  const { canPrompt, installed, install } = usePwaInstall();
  const [open, setOpen] = useState(false);
  if (installed) return null;

  const handleClick = async () => {
    if (!canPrompt) return setOpen(true);
    if (await install()) toast.success("Aplikasi berhasil di-install di perangkat Anda");
  };

  return (
    <>
      <Button
        onClick={handleClick}
        className={
          variant === "hero"
            ? "h-11 rounded-full bg-emerald-500 px-6 text-sm font-bold text-white shadow-lg shadow-emerald-500/30 transition-transform hover:bg-emerald-400 active:scale-95"
            : "h-9 rounded-full bg-emerald-500 px-3 text-sm font-semibold text-white shadow-md shadow-emerald-500/20 transition-transform hover:bg-emerald-400 active:scale-95 sm:px-4"
        }
        data-testid="pwa-install-btn"
      >
        <Smartphone className={variant === "hero" ? "h-5 w-5" : "h-4 w-4"} />
        <span>Install Aplikasi</span>
      </Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-md rounded-3xl" data-testid="pwa-install-dialog">
          <DialogHeader>
            <DialogTitle className="font-heading text-xl">Install Aplikasi di HP</DialogTitle>
            <DialogDescription>Pasang aplikasi Pengaduan RT di layar utama agar bisa dibuka seperti aplikasi biasa.</DialogDescription>
          </DialogHeader>
          <ol className="space-y-3">
            {STEPS.map((step, i) => (
              <li key={step.title} className="flex gap-3 rounded-2xl border border-slate-200 bg-slate-50 p-3">
                <span className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-xs font-bold text-white">{i + 1}</span>
                <div>
                  <p className="text-sm font-semibold text-slate-900">{step.title}</p>
                  <p className="text-sm text-slate-600">{step.text}</p>
                </div>
              </li>
            ))}
          </ol>
        </DialogContent>
      </Dialog>
    </>
  );
};
